__turbopack_context__.v({
  "cardWrapper": "Huxjaq_cardWrapper",
  "color": "Huxjaq_color",
  "comboSubtitle": "Huxjaq_comboSubtitle",
  "comboTitle": "Huxjaq_comboTitle",
  "comboTitleWrapper": "Huxjaq_comboTitleWrapper",
  "header": "Huxjaq_header",
  "headingTitle": "Huxjaq_headingTitle",
  "mask": "Huxjaq_mask",
});
